export default __webpack_public_path__ + "static/media/editProfileUnknow.ed66e0c8.svg";